export const campaignSegmentType = {
  klaviyo: "klaviyo",
  brevo: "brevo",
  shopify: "shopify",
  hubspot: "hubspot",
  simioSegment: "simioSegment",
};
